"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const constants_1 = require("../../constants");
const rich_text_1 = require("@vedalib/rich-text");
exports.TYPE = 'splitter';
exports.DEFAULT_VALUE = {
    leftBlock: {
        image: constants_1.imageValueWithObjectFit,
        showImage: false,
        text: (0, rich_text_1.textToRtValue)('', rich_text_1.SlateElementType.heading3),
        overlay: null,
    },
    rightBlock: {
        image: constants_1.imageValueWithObjectFit,
        showImage: false,
        text: (0, rich_text_1.textToRtValue)('', rich_text_1.SlateElementType.heading3),
        overlay: null,
    },
    position: 50,
};
